import { useRequest } from 'features/request/useRequest';
import type { ChapterEnum } from 'gql/graphql';

import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import type { IFiltersWhere } from '../helpers';
import { getWhere, getWorkOrderWhereFromFilter } from '../helpers';
import type { SearchWhere } from '../InflationDistributionModal';
import { uerWorkOrderActKC2MtrForInflationDistributionGql } from '../InflationDistributionModalQueries';

export const useGetActKC2MtrForInflation = (
    actKC2Id: number,
    workOrderSubObjectId: number,
    chapter: ChapterEnum,
    queryWhere?: SearchWhere,
) => {
    const [filtersWhere, setFiltersWhere] = useState<IFiltersWhere | undefined>(undefined);

    const changeFilterHandler = useCallback(({ fieldName, checkedValues }) => {
        setFiltersWhere((prevValues) => ({
            and: {
                ...prevValues?.and,
                ...getWorkOrderWhereFromFilter(fieldName, checkedValues),
            },
        }));
    }, []);

    const searchValue = queryWhere?.value && queryWhere?.value.length > 0 ? queryWhere : undefined;

    const variables = useMemo(
        () => ({
            actKC2Id,
            workOrderObjectId: workOrderSubObjectId,
            chapter,
            where: getWhere(searchValue, filtersWhere),
        }),
        [actKC2Id, chapter, filtersWhere, searchValue, workOrderSubObjectId],
    );
    const dispatch = useDispatch();

    const [data, status, error, makeRequest] = useRequest({
        requestId: 'uerWorkOrderActKC2MtrForInflationDistribution',
        query: uerWorkOrderActKC2MtrForInflationDistributionGql,
        variables,
        withEffect: true,
    });

    const refreshActKC2MtrForInflation = useCallback(() => {
        dispatch(makeRequest(variables));
    }, [dispatch, makeRequest, variables]);

    return [
        data?.uerWorkOrderActKC2MtrForInflationDistribution?.items,
        status,
        error,
        refreshActKC2MtrForInflation,
        changeFilterHandler,
    ];
};
